import { render, staticRenderFns } from "./pwdchange.vue?vue&type=template&id=6a9d68af&"
import script from "./pwdchange.vue?vue&type=script&lang=js&"
export * from "./pwdchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports